import { Button, Layout, theme, Typography } from "antd";
import CollapseIcon from "./CollapseIcon";
import { MenuOutlined } from "@ant-design/icons"; // Import MenuOutlined for the burger icon
import { useLocation } from "react-router-dom";

const { Header } = Layout;
const { Title } = Typography;

const HeaderComponent = ({
  toggleCollapsed,
  collapsed,
  responsive,
  showDrawer,
}) => {
  const location = useLocation();
  const {
    token: { headerBg },
  } = theme.useToken();
  const titleMap = {
    "/newsletter/send": "Create Newsletter",
  };


  const getPageTitle = () => {
    const customTitle = titleMap[location.pathname];
  if (customTitle) return customTitle;
  
    return location.pathname
      .replace(/\d+/g, "") // Remove digits
      .replace(/\//g, " ") // Replace "/" with space
      .replace(/-/g, " ") // Replace "-" with space
      .replace(/\s+/g, " ") // Handle any extra spaces
      .trim() // Trim any leading/trailing spaces
      .toLowerCase() // Convert entire string to lowercase
      .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize the first letter of each word
      .replace(/\s+/g, " "); // Remove all spaces after transforming
  };

  return (
    <Header style={{ padding: 0, background: headerBg }}>
      <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
        {responsive ? (
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={showDrawer} // Open drawer when clicked
            style={{ fontSize: "16px" }}
          />
        ) : (
          <Button
            type="text"
            icon={<CollapseIcon />}
            onClick={() => toggleCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              transform: `translate(-50%) rotate(${
                collapsed ? "180deg" : "0deg"
              })`,
            }}
          />
        )}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            paddingRight: "20px",
          }}
        >
          <Title level={4} style={{ margin: 0 }}>
            {getPageTitle()}
          </Title>
        </div>
      </div>
    </Header>
  );
};

export default HeaderComponent;
